import { useState, useRef } from 'react';

/**
 * useEffect with AbortController injection to fetch request:
 *
 * @param {Function} callback - Function. Function to execute after the delay.
 * @param {Number} delay - (Optional) Number. setTimeout's delay.
 *
 */

export function useDebounceRef(callback, delay = 600) {
  const debounceTimeout = useRef(null);
  const debouncedValue = useRef('');

  function debounceFunction(value) {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      const result = callback(value);
      debouncedValue.current = result !== undefined ? result : value;
    }, delay);
  }

  return [debouncedValue.current, debounceFunction];
}

export function useDebounceState(initialValue, delay) {
  const [debouncedValue, setDebouncedValue] = useState(initialValue);
  const debounceTimeout = useRef(null);

  function debounceFunction(value) {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
  }

  return [debouncedValue, debounceFunction];
}
